import { render, staticRenderFns } from "./VariableDetail.vue?vue&type=template&id=26262bb1"
import script from "./VariableDetail.vue?vue&type=script&lang=js"
export * from "./VariableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports